export default __webpack_public_path__ + "static/media/q7_04_sp.c5fea86d.jpg";